import { useMemo } from 'react'

import { useRequest } from 'ahooks'
import { Spin, Tabs, TabsProps } from 'antd'

import { queryNewsCatalogueRootListApi } from '@eastcoal/api/content/newsCatalogueMall/queryNewsCatalogueRootList'

import { NewsList } from '../List'

import { NewsTabsProps } from './interface'

const DEFAULT_ITEMS: TabsProps['items'] = [
  {
    key: 'news',
    label: '行业新闻',
    children: <NewsList />
  },
  {
    key: 'focus',
    label: '市场聚焦',
    children: <NewsList />
  },
  {
    key: 'tuCao',
    label: '煤市吐槽',
    children: <NewsList />
  }
]

export const NewsTabs = ({ value, onChange }: NewsTabsProps) => {
  const { data, loading, error } = useRequest(queryNewsCatalogueRootListApi, {
    manual: false,
    defaultParams: [
      {
        size: '6'
      }
    ],
    onSuccess: data => {
      if (data?.length) {
        onChange(data[0].code)
      }
    }
  })

  const items = useMemo(() => {
    if (error) {
      return DEFAULT_ITEMS
    }
    if (!data?.length) {
      return DEFAULT_ITEMS
    }
    return data.map(item => {
      return {
        key: `${item.code}`,
        label: item.name,
        children: <NewsList catalogueCode={item.code} />
      }
    })
  }, [data, error])

  return (
    <Spin spinning={loading}>
      <Tabs
        activeKey={value}
        items={items}
        size='small'
        tabBarGutter={-1}
        type='card'
        tabBarStyle={{
          marginBlock: 0
        }}
        onChange={onChange}
      />
    </Spin>
  )
}
